import ProductGrid from "components/ProductGrid";
import type { Product } from "data/products";

export default function RelatedProducts({
  relatedProducts,
}: {
  relatedProducts: Product[];
}) {
  return (
    <>
      <h2>Découvrez le reste de notre gamme</h2>
      <ProductGrid products={relatedProducts} />
    </>
  );
}
